import React from "react";
import { CONTEXT_MANAGEMENT_READ_ONLY_MESSAGE, CONTEXT_MANAGEMENT_REACTIVATION_MESSAGE } from "@domain/valueObjects/contextManagementEntitlement";

const badgeStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 10px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
  color: "#92400e",
  background: "#fef3c7",
  border: "1px solid #fde68a",
};

/**
Marks a non-default team/project as read-only due to absent Context Management entitlement (WP8) - never hidden, per design.md.
*/
export const EntitlementLockedBadge: React.FC = () => {
  return (
    <span style={badgeStyle} title={`${CONTEXT_MANAGEMENT_READ_ONLY_MESSAGE} ${CONTEXT_MANAGEMENT_REACTIVATION_MESSAGE}`}>
      Read-only
    </span>
  );
};
